import { SWMS_CATEGORY_MANAGEMENT_URL, SWMS_CATEGORY_FILTERS_URL, ADD_EDIT_CATEGORY_URL, GET_SWMS_CATEGORY_FILTERS } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getCategoryDetails = (page = 1, params = {}, abortController) => () => {
  return scopeApiInstance.get(SWMS_CATEGORY_MANAGEMENT_URL, { params: { page, ...params }, ...abortController }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getCategoryFilters = (abortController) => async (dispatch) => {
  return scopeApiInstance.get(SWMS_CATEGORY_FILTERS_URL, { ...abortController }).then((res) => {
    if (res && res.data && res.data.data) {
      dispatch({
        type: GET_SWMS_CATEGORY_FILTERS,
        payload: res.data.data
      });
      return Promise.resolve(res.data.data);
    } else {
      dispatch({
        type: GET_SWMS_CATEGORY_FILTERS,
        payload: { 'catrgories:': [], 'methods': [] }
      });
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const addUpdateCategory = (formData, isAdding = false) => () => {
  const method = isAdding ? scopeApiInstance.post : scopeApiInstance.put
  const url = isAdding ? SWMS_CATEGORY_MANAGEMENT_URL : `${SWMS_CATEGORY_MANAGEMENT_URL}/${formData.id}`;
  return method(url, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

